import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_TOUR_PRACTICAL_INFO } from 'Utils/request/requestDictionary';
export type CMSProps = {
  healthFormalities: string;
  immigrationFormalities: string;
  includedInTour: string;
  notIncludedInTour: string;
  resortId: string;
};
type GQLProps = {
  resort: {
    practicalInformation: {
      healthFormalities: string;
      passportAndVisas: string;
      includedInPackage: Array<string>;
      excludedInPackage: Array<string>;
    };
  };
};
export type ResolvedProps = CMSProps & GQLProps;
export const resolve: Resolve<GQLProps, CMSProps> = async (appContext, props) => {
  const { resortId: productId } = props;
  const query = `query {
    resort(resortId:"${productId}"){
      practicalInformation {
        healthFormalities
        passportAndVisas
        includedInPackage
        excludedInPackage
      }
    }
  }`;
  return graphQLClient.runQuery(query, appContext, {
    requestName: LINE_TOUR_PRACTICAL_INFO,
    strictErrors: false,
  });
};
